import { useAuth0 } from '@auth0/auth0-react'
const AUTH_AUDIENCE = process.env.VITE_AUTH_AUDIENCE ?? ''

/** A model to control authentication actions like login and logout. */
export interface AuthenticationModel {
  /** The ID of the currently authenticated user */
  authenticatedUserId?: string
  /** Triggers a login transaction that redirects the user to the login page of the authentication provider */
  login: () => void
  /** Logs the current user out of the application */
  logout: () => void
}

/**
 * Returns a module that deals with logging users in and out of the application.
 * @returns
 * @category Authentication
 */
export function useAuthenticationModel(): AuthenticationModel {
  const { loginWithRedirect, user, logout } = useAuth0()
  return {
    authenticatedUserId: user?.sub,
    login: () => loginWithRedirect({ audience: AUTH_AUDIENCE }),
    logout: () => logout({ returnTo: window.location.origin }),
  }
}
